export const generateScreenplayHTML = (
  title: string,
  scenes: any[],
  authorName: string
): string => {
  const sceneHTML = scenes
    .map(
      (scene) => `
    <div class="scene">
      <div class="scene-number">SCENE ${scene.scene_number}</div>
      <div class="scene-content">
        ${scene.elements
          .map((element: any) => {
            if (element.element_type === 'location') {
              return `
                <div class="location">
                  <strong>LOCATION:</strong> ${element.content || '(No location specified)'}
                </div>
              `;
            } else if (element.element_type === 'narration') {
              return `
                <div class="narration">
                  ${element.content || '(No narration text)'}
                </div>
              `;
            } else if (element.element_type === 'dialogue') {
              return `
                <div class="dialogue">
                  <div class="character-name">${element.character_name || 'CHARACTER'}</div>
                  <div class="dialogue-text">${element.content || '(No dialogue)'}</div>
                </div>
              `;
            }
            return '';
          })
          .join('')}
      </div>
    </div>
  `
    )
    .join('');

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${title} - Screenplay</title>
  <style>
    /* ============================================
       SCREENPLAY TEMPLATE STYLES
       You can customize fonts, colors, spacing here
       ============================================ */
    
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    @page {
      size: A4;
      margin: 1in;
    }

    body {
      font-family: 'Courier New', Courier, monospace;
      font-size: 12pt;
      line-height: 1.5;
      color: #000;
      background: #fff;
      max-width: 8.5in;
      margin: 0 auto;
      padding: 20px;
    }

    /* Title Page */
    .title-page {
      text-align: center;
      margin-bottom: 60px;
      padding-top: 100px;
      page-break-after: always;
    }

    .screenplay-title {
      font-size: 24pt;
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 40px;
      letter-spacing: 2px;
    }

    .screenplay-subtitle {
      font-size: 14pt;
      margin-bottom: 20px;
      font-style: italic;
    }

    .author-info {
      margin-top: 60px;
      font-size: 12pt;
    }

    .date-info {
      margin-top: 20px;
      font-size: 11pt;
      color: #666;
    }

    /* Scene Container */
    .scene {
      display: flex;
      margin-bottom: 40px;
      page-break-inside: avoid;
      position: relative;
    }

    /* Scene Number (Left Side) */
    .scene-number {
      position: absolute;
      left: -80px;
      top: 0;
      width: 60px;
      text-align: right;
      font-weight: bold;
      font-size: 11pt;
      color: #333;
      padding-right: 10px;
    }

    /* Scene Content (Main Area) */
    .scene-content {
      flex: 1;
      padding-left: 0;
    }

    /* Location */
    .location {
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 15px;
      font-size: 12pt;
      letter-spacing: 1px;
    }

    /* Narration (Action/Description) */
    .narration {
      margin-bottom: 15px;
      text-align: center;
      font-size: 12pt;
      line-height: 1.6;
      padding: 0 60px;
      font-style: italic;
      color: #222;
    }

    /* Dialogue Block */
    .dialogue {
      margin-bottom: 20px;
      margin-left: 100px;
      max-width: 400px;
    }

    /* Character Name */
    .character-name {
      text-transform: uppercase;
      font-weight: bold;
      margin-bottom: 5px;
      text-align: center;
      font-size: 12pt;
      letter-spacing: 1px;
    }

    /* Dialogue Text */
    .dialogue-text {
      text-align: left;
      line-height: 1.5;
      margin-left: 20px;
      margin-right: 20px;
    }

    /* Page Break Control */
    .scene {
      page-break-inside: avoid;
    }

    .dialogue {
      page-break-inside: avoid;
    }

    /* Print Styles */
    @media print {
      body {
        margin: 0;
        padding: 0;
      }

      .scene-number {
        left: -60px;
      }

      @page {
        margin: 1in;
      }
    }
  </style>
</head>
<body>
  <!-- Title Page -->
  <div class="title-page">
    <div class="screenplay-title">${title}</div>
    <div class="screenplay-subtitle">A Screenplay</div>
    <div class="author-info">
      <div>Written by</div>
      <div><strong>${authorName}</strong></div>
    </div>
    <div class="date-info">${new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })}</div>
  </div>

  <!-- Screenplay Content -->
  <div class="screenplay-content">
    ${sceneHTML}
  </div>

  <!-- Footer -->
  <div style="margin-top: 60px; text-align: center; font-size: 10pt; color: #999; border-top: 1px solid #ddd; padding-top: 20px;">
    <p>Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
  </div>
</body>
</html>
  `;
};